import { render, staticRenderFns } from "./WorkBookQuestionsOpenAdditional.vue?vue&type=template&id=35fbb3b2&scoped=true&"
import script from "./WorkBookQuestionsOpenAdditional.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsOpenAdditional.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsOpenAdditional.vue?vue&type=style&index=0&id=35fbb3b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fbb3b2",
  null
  
)

export default component.exports